type JwtProfileData = {
  profile?: {
    status?: string;
  };
  required_actions?: {
    profile_update?: boolean;
  };
};

type JwtPayload = {
  data?: JwtProfileData;
  exp?: number;
  iat?: number;
  [key: string]: unknown;
};

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const payload = parts[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

type BiletoUserCookie = {
  email?: string;
  name?: string;
  authToken?: string;
  expires?: string;
  extraData?: Record<string, unknown>;
};

export function getJwtFromBiletoUserCookie(): string | null {
  if (typeof document === 'undefined') return null;

  try {
    const cookies = document.cookie.split(';');
    const biletoCookie = cookies.find((cookie) => cookie.trim().startsWith('bileto.user='));

    if (!biletoCookie) return null;

    const cookieValue = biletoCookie.split('=').slice(1).join('=');
    const decodedValue = decodeURIComponent(cookieValue);
    const parsed: BiletoUserCookie = JSON.parse(decodedValue);

    return parsed.authToken || null;
  } catch {
    return null;
  }
}

export function shouldShowProfileCompletionBanner(token: string | undefined | null): boolean {
  if (!token) return false;

  const payload = decodeJwt(token);
  if (!payload?.data) return false;

  const { profile, required_actions } = payload.data;

  const isProfileIncomplete = profile?.status?.toUpperCase() === 'INCOMPLETED';
  const shouldUpdateProfile = required_actions?.profile_update === true;

  return isProfileIncomplete && shouldUpdateProfile;
}
